/* eslint react/prop-types: 0 */
import React from "react"
// import { SideBarContext, initialSideBarState } from "context/sidebarContextWrapper"
import useSiteMetadata from "hooks/use-site-metadata"
import { FUSION_CONNECTORS_TAG, FUSION_TAG, FUSION_SERVER_TAG, FUSION_AI_TAG, APP_STUDIO_TAG } from "config/productItems";

export default function SEO({ 
    title,
    description, 
    pathname = '',
    keywords = [], 
    subtitle = null,
    slug = '', 
    permalink = null, 
    product = '', 
    productVersion = [], 
    objective = '', 
    persona = '',
    docType = '',
    embed = null
}){

  const { title: defaultTitle, description: defaultDescription, siteUrl, articlesDirectoryUrl } = useSiteMetadata()

  const seo = {
    title: `${title}`,
    description: description || defaultDescription,
    url: `${siteUrl}${pathname || ``}`,
    articlesDirectoryUrl
  }

  let ogPath = siteUrl

  switch(product){
    case FUSION_TAG:
    case FUSION_CONNECTORS_TAG:
    case FUSION_SERVER_TAG:
    case FUSION_AI_TAG:
    case APP_STUDIO_TAG:
      if(docType === 'howto'){
        ogPath += `/images/opengraph/${docType}/${product}/howto.jpg`
        break;
      }
      ogPath += `/images/opengraph/${docType}/${product}/${productVersion}.jpg`
      break;
    default:
      ogPath += `/images/opengraph/default.jpg`
      break;
  }
  // const state = useContext(SideBarContext) || initialSideBarState;

  const pageTitle = subtitle ? `${seo.title} - ${subtitle}` : seo.title;
  return (
    <>
      <title>{`${pageTitle} | Legacy ${defaultTitle}`}</title>

      <link rel="canonical" href={seo.url + slug} />
      <meta name="description" content={seo.description} />
      
      <meta property='og:url' content={seo.url + slug} />
      <meta property='og:title' content={seo.title} />
      <meta property='og:description' content={seo.description} />
      <meta property='og:type' content='website' />
      <meta property='og:image' content={ogPath} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content="Lucidworks" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name='twitter:image' content={ogPath} />

      {subtitle && (<meta name='subtitle' content={subtitle} />)}
      {keywords.length > 0 && (<meta name='keywords' content={keywords.join(`, `)} />)}
      {permalink && (<meta name='permalink' content={permalink} />)}
      {product && (<meta name='productName' content={product} />)}
      {productVersion?.length > 0 && (<meta name='productVersion' content={productVersion} />)}
      {objective && (<meta name='objective' content={objective} />)}
      {persona && (<meta name='persona' content={persona} />)}
      {docType && (<meta name="docType" content={docType} />)}

      {/* permalink for Fusion Connectors (only Fusion page that uses tab.js) */}
      {(permalink === "2" || permalink === "bm4fad") ? <script defer src='/assets/js/tabs.js' type="text/javascript"/> : null}

      {embed && (<script 
                    type="module" 
                    id="lw-ui-lib" 
                    api-url="https://d4a05adf-a563-4e5e-b121-2a80ce1dc615.applications.lucidworks.com"  // eslint-disable-line react/no-unknown-property
                    embed-token="WDC1zqribwPXpVecREGLiGTTw7Ip09JT" // eslint-disable-line react/no-unknown-property
                    src="https://storage.googleapis.com/sb-ui/springboard.esm.js" />)}      
      
    </>
  )
}